import { SvgIcon, SvgIconProps} from '@mui/material';
import './ccf-elevated-phone-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfElevatedPhoneIconProps extends SvgIconProps {}

/**
 *
 * @param props -
 * @example
 * @returns
 */
export function CcfElevatedPhoneIcon(props: CcfElevatedPhoneIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        d="M9.78314 8.71025C9.78314 8.71025 9.22322 9.62012 9.17358 9.69719C9.12394 9.77425 9.01335 10.0028 8.49174 9.84869C7.28875 9.37876 6.2252 8.60735 5.40212 7.60773C4.42916 6.73453 3.68759 5.63155 3.24427 4.39823C3.09536 3.85616 3.31567 3.74407 3.38969 3.68977C3.46371 3.63548 4.33974 3.05401 4.33974 3.05401C4.92928 2.69496 4.26224 1.15983 3.18767 0.420729C2.39436 -0.125718 2.04604 -0.0714241 1.71252 0.197421C1.16933 0.64922 0.683539 1.16657 0.266115 1.7378C0.054756 2.04427 -0.0355789 2.41888 0.0127108 2.78866C0.186936 3.95725 0.588799 5.07977 1.19526 6.09186C1.87885 7.29434 2.71647 8.40137 3.68664 9.38455C4.62419 10.3848 5.68981 11.2553 6.8555 11.9732C7.82043 12.5993 8.90431 13.0168 10.0383 13.1992C10.3968 13.2485 10.7602 13.1541 11.0502 12.9365C11.6032 12.4983 12.1004 11.9933 12.5305 11.4329C12.7918 11.0826 12.8397 10.7253 12.3146 9.90035C11.6066 8.78994 10.1289 8.09813 9.78314 8.71025Z"
        fill="#007AB8"
      />
    </SvgIcon>
  );
}

export default CcfElevatedPhoneIcon;
